// removed by extract-text-webpack-plugin
module.exports = {"type_progress_bar":"type_progress_bar","type_progress_bar_wrapper":"type_progress_bar_wrapper","type_progress_bar_percent":"type_progress_bar_percent","dark":"dark"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Project/components/TypeProgressBar/style.scss
// module id = 1371
// module chunks = 0